import {
	CampaignObjective,
	CreateCreativeType,
	CreateGroupBidType,
} from 'wb-reddit/graphql/generated';
import { RedditLevel } from 'wb-reddit/app/routes/superGrid/utils';
import { SuperGridValidationEntity } from '@aleph/supergrid';
import { RedditCreateData } from 'wb-reddit/app/routes/superGrid/mutator/utils';

export const getGroupBidTypeForObjective = (objective: CampaignObjective): CreateGroupBidType => {
	switch (objective) {
		case CampaignObjective.Impressions: // BRAND AWARENESS AND REACH
			return CreateGroupBidType.Cpm;
		case CampaignObjective.VideoViewableImpressions: // VIEW VIEWS
			return CreateGroupBidType.Cpv;
	}

	return CreateGroupBidType.Cpc;
};

export const preValidateCreatives = (creatives: RedditCreateData[]): SuperGridValidationEntity[] => {
	const errors: SuperGridValidationEntity[] = [];

	creatives.forEach(creative => {
		if (creative.creativeType === CreateCreativeType.Video && !creative.creativeThumbnailUrl) {
			errors.push({
				id:      creative.hash,
				level:   RedditLevel.AD,
				field:   'creativeThumbnailUrl',
				message: 'Thumbnail is required for video creatives',
			});
		}
	});

	return errors;
};

// TODO: add ad specific validations & append creative validations
export const preValidateAds = (ads: RedditCreateData[]): SuperGridValidationEntity[] => [
	...preValidateCreatives(ads),
];
